<template>
  <div class="input-icon">
    <i class="fas fa-lock" aria-hidden="true"></i>
    <input
      :id="id"
      :value="modelValue"
      :type="visible ? 'text' : 'password'"
      class="form-control"
      :autocomplete="autocomplete"
      :aria-invalid="invalid ? 'true' : undefined"
      :aria-describedby="invalid ? `${id}-error` : undefined"
      maxlength="255"
      autocapitalize="none"
      spellcheck="false"
      required
      @input="$emit('update:modelValue', $event.target.value)"
      @keyup="capsLock = $event.getModifierState && $event.getModifierState('CapsLock')"
    />
    <button type="button" class="input-icon__toggle" :aria-label="visible ? 'Masquer le mot de passe' : 'Afficher le mot de passe'" :aria-pressed="visible" @click="visible = !visible">
      <i :class="visible ? 'fas fa-eye-slash' : 'fas fa-eye'" aria-hidden="true"></i>
    </button>
  </div>
  <small v-if="capsLock" class="text-warning d-block mt-1"><i class="fas fa-triangle-exclamation me-1" aria-hidden="true"></i>Verrouillage majuscule activé</small>
</template>

<script setup>
import { ref } from "vue";

/**
 * Champ mot de passe avec bouton afficher / masquer (la valeur n'est jamais affichée hors du champ).
 */
defineProps({
  modelValue: { type: String, default: "" },
  id: { type: String, required: true },
  autocomplete: { type: String, default: "new-password" },
  invalid: { type: Boolean, default: false },
});
defineEmits(["update:modelValue"]);

const visible = ref(false);
const capsLock = ref(false);
</script>

<style scoped>
.input-icon {
  position: relative;
}
.input-icon > i {
  position: absolute;
  left: 0.85rem;
  top: 50%;
  transform: translateY(-50%);
  color: hsl(var(--muted-foreground));
  font-size: 0.85rem;
}
.input-icon .form-control {
  padding-left: 2.3rem;
  padding-right: 2.5rem;
  height: 44px;
}
.input-icon__toggle {
  position: absolute;
  right: 0.35rem;
  top: 50%;
  transform: translateY(-50%);
  border: 0;
  background: transparent;
  color: hsl(var(--muted-foreground));
  padding: 0.4rem 0.55rem;
}
</style>
